import { AssignedCustomerServiceModel } from '@app/sales/modules/details/models/assigned-customer-services.model';
import {
  CustomerServiceOffering,
  CustomerServiceOfferingResponse,
} from '@sales/modules/details/models/customer-service-offering.model';

export class CustomerServiceProductAddAction {
  public static readonly type = '[Product] Add customer service product';
  constructor(public offering: CustomerServiceOffering) {}
}

export class CustomerServiceProductRemoveAction {
  public static readonly type = '[Product] Remove customer service product';
  constructor(public productId: string) {}
}

export class ApiGetAvailableCustomerServiceOfferingsAction {
  public static readonly type = '[Api] Get available customer service offerings';
  constructor(public customerId: string) {}
}

export class ApiGetAvailableCustomerServiceOfferingsSuccessAction {
  static readonly type = '[Api] Get available customer service offerings success';
  constructor(public customerOfferingServiceResponse: CustomerServiceOfferingResponse) {}
}

export class ApiGetAvailableCustomerServiceOfferingsErrorAction {
  static readonly type = '[Api] Get available customer service offerings Error';
}

export class ApiGetAllCustomerServiceOfferingsAction {
  public static readonly type = '[Api] Get all customer service offerings';
}

export class ApiGetAllCustomerServiceOfferingsSuccessAction {
  static readonly type = '[Api] Get all customer service offerings success';
  constructor(public customerOfferingServiceResponse: CustomerServiceOfferingResponse) {}
}

export class ApiGetAllCustomerServiceOfferingsErrorAction {
  static readonly type = '[Api] Get all customer service offerings Error';
}

export class ApiGetAssignedCustomerServiceProductsAction {
  public static readonly type = '[Api] Get assigned customer service products';
  constructor(public customerId: string) {}
}

export class ApiGetAssignedCustomerServiceProductsSuccessAction {
  static readonly type = '[Api] Get assigned customer service products success';
  constructor(public assignedCustomerServices: AssignedCustomerServiceModel[]) {}
}

export class ApiGetAssignedCustomerServiceProductsErrorAction {
  static readonly type = '[Api] Get assigned customer service products Error';
}

export class CustomerServiceProductResetAction {
  static readonly type = '[Product] Reset customer service product state';
}
